import { localizeSystemText } from '../../i18n/messages';
import LocalizedMessage from '../common/LocalizedMessage';
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  timeRanges,
  daysOfWeek,
  typeCheckboxes,
  tooltips,
  inputProps,
} from "./SignupData";
import Checkbox from "../common/Checkbox";
import Input from "../common/Input";
import Tooltip from "../common/Tooltip";
import SelectInput from "../common/SelectInput";
import { useTranslation } from 'react-i18next';

const SignupForm = ({ formData, onChange, onSubmit, errors, disabled }) => {
  const { t: tr } = useTranslation();
  const isValid = error => (error ? "is-invalid" : "");
  return (
    <div>
      <h2 className="signup-page-title">{tr("public:signUpForClasses_140")}</h2>
      <p className="mb-4">{tr("public:completeTheFormTodayAndLearnEnglishPlacesAre_141")}</p>

      <form id="signup-form ml-0 mr-0 mt-2" onSubmit={onSubmit}>
        <div className="signup-form-row form-row">
          <div className="col-lg-6 pl-2">
            <div className="signup-form-row form-row">{tr("public:contactDetails_142")}</div>
            <Input {...inputProps.email} value={formData.email} error={errors.email} onChange={onChange}/>
            <div className="signup-form-row form-row">
              <div className="col-lg-4 pl-0">
                <Input
                  {...inputProps.name}
                  value={formData.name}
                  error={errors.name}
                  onChange={onChange}
                />
              </div>
              <div className="col-lg-4 pl-0">
                <Input
                  {...inputProps.surname}
                  value={formData.surname}
                  error={errors.surname}
                  onChange={onChange}
                />
              </div>
              <div className="col-lg-4 pl-0">
                <Input
                  {...inputProps.phone}
                  value={formData.phone}
                  error={errors.phone}
                  onChange={onChange}
                />
              </div>
            </div>

            <div className="signup-form-row form-row">{tr("public:studentDetails_143")}</div>
            <div className="signup-form-row form-row">
              <div className="col-lg-4 mb-1">
                <Input
                  {...inputProps.childname}
                  value={formData.childname}
                  error={errors.childname}
                  onChange={onChange}
                />
              </div>
              <div className="col-lg-4 mb-1">
                <SelectInput
                  label={tr("public:age_144")}
                  onChange={onChange}
                  name="age"
                  defaultOption={tr("common:chooseAge")}
                  value={formData.age}
                  options={Array.from({ length: 18 }, (value, index) => ({
                    value: (index + 1).toString(),
                    text: (index + 1).toString(),
                  }))}
                />

              </div>
            </div>
            <div className="signup-form-row form-row">
              <div className="col-lg-4 pl-0">
                <div className="signup-form-row form-row signup-info">{tr("public:experienceWithEnglish_145")}<Tooltip description={localizeSystemText(tooltips.contact, tr)} />
                </div>
                <div className="radio-container">
                  {["Tak", "Nie"].map(level => (
                    <div key={level} className="radio-item">
                      <input
                        type="radio"
                        name="level"
                        value={level}
                        className={`form-check-input ${
                          errors.level ? "is-invalid" : ""
                        }`}
                        onChange={onChange}
                        id={`level-${level}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`level-${level}`}
                      >
                        {localizeSystemText(level, tr)}
                      </label>
                    </div>
                  ))}
                  {errors.level && (
                    <div className="invalid-feedback"><LocalizedMessage isError value={errors.level} /></div>
                  )}
                </div>
              </div>
            </div>
            <div className="signup-form-row form-row">
              <Input
                {...inputProps.leveldesc}
                className="w-100"
                value={formData.leveldesc}
                error={errors.leveldesc}
                onChange={onChange}
              />
            </div>
            <Checkbox
              name="permission"
              className="signup"
              onChange={onChange}
              error={errors.permission}
              isChecked={formData.permission}
              textPosition="rightOnLarge"
              label={tr("public:iConsentToTheStorageAndProcessingOfMy_146")}
              styleOptions={{
                errorPosition: "belowOnLarge",
                fontStyle: "signup-checkbox signup-info",
                labelBold: false,
                centerContent: false,
                narrowCheckbox: true,
              }}
            />
            <div className="row d-flex align-items-center form-group">
              <div className="d-flex col-12 justify-content-center p-0 pl-xl-3 mr-md-1 mb-1 mb-md-0 align-items-center signup-checkbox signup-info col-md-1">
                <input
                  type="checkbox"
                  name="termsAccepted"
                  aria-label={tr("public:iAcceptTheTermsOfService_147")}
                  className={`form-control input-checkbox ${isValid(errors.termsAccepted)}`}
                  checked={formData.termsAccepted}
                  disabled={disabled}
                  onChange={event => onChange({
                    ...event,
                    target: { name: "termsAccepted", value: event.target.checked },
                  })}
                />
              </div>
              <span className="d-flex col-12 justify-content-center p-0 signup-checkbox signup-info col-md-10 justify-content-md-start">{tr("public:iAcceptThe_148")}{" "}
                <Link to="/terms" target="_blank" rel="noopener noreferrer" className="ml-1">{tr("public:termsOfService_149")}</Link>
              </span>
              <div className="row pl-0 w-100">
                <div className="col-lg-12 d-block invalid-feedback pt-2 pl-3">
                  <LocalizedMessage isError value={errors.termsAccepted} />
                </div>
              </div>
            </div>
            <div className="signup-form-row form-row" />
          </div>
          <div className="col-lg-6 pl-4">
            <div className="signup-form-row form-row">{tr("public:lessonType_150")}<Tooltip description={localizeSystemText(tooltips.type, tr)} />
            </div>
            <div className="input-group signup-form-row form-row form-column-container">
              {typeCheckboxes.map(checkbox => (
                <div
                  className={`mb-3 form-column form-control ${isValid(
                    errors[checkbox.name]
                  )}`}
                  key={checkbox.name}
                >
                  <Checkbox
                    name={checkbox.name}
                    className="signup"
                    onChange={onChange}
                    textPosition="belowOnLarge"
                    isChecked={formData[checkbox.name]}
                    label={localizeSystemText(checkbox.label, tr)}
                    styleOptions={{
                      errorPosition: "belowOnLarge",
                      fontStyle: "signup-checkbox signup-info",
                      labelBold: false,
                    }}
                  />
                </div>
              ))}
              <div className="invalid-feedback text-left mt-2">
                <LocalizedMessage isError value={errors.typei} />
              </div>
            </div>

            <div className="signup-form-row form-row">{tr("public:preferredClassTimes_151")}<Tooltip description={localizeSystemText(tooltips.time, tr)} />
            </div>
            <div className="signup-form-row form-row">
              <div className="col-lg-12 pl-0">
                <label className="signup-info signup-info-time">{tr("public:days_152")}</label>
                <div className="input-group signup-form-row form-row form-column-container">
                  {daysOfWeek.map(day => (
                    <div className="form-column text-center" key={day}>
                      <Checkbox
                        name={day}
                        className="signup"
                        onChange={onChange}
                        textPosition="belowOnLarge"
                        isChecked={formData.days[day]}
                        label={localizeSystemText(day, tr)}
                        styleOptions={{
                          errorPosition: "belowOnLarge",
                          fontStyle: "signup-checkbox signup-info",
                          labelBold: false,
                        }}
                      />

                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="signup-form-row form-row">
              <div className="col-lg-12 pl-0">
                <div className="signup-info signup-info-time">{tr("public:hours_153")}</div>
                <div className="input-group signup-form-row form-row form-column-container">
                  {timeRanges.map(range => (
                    <div className="form-column text-center" key={range}>
                      <Checkbox
                        name={range}
                        className="signup"
                        onChange={onChange}
                        textPosition="belowOnLarge"
                        isChecked={formData.times[range]}
                        label={range}
                        styleOptions={{
                          errorPosition: "belowOnLarge",
                          fontStyle: "signup-checkbox signup-info",
                          labelBold: false,
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="signup-form-row form-row">
              <div className="col-lg-12 pl-0 h-100">
                <Input
                  {...inputProps.desc}
                  className="w-100"
                  value={formData.desc}
                  error={errors.desc}
                  onChange={onChange}
                />
              </div>
            </div>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-danger font-weight-bold btn-block"
          style={{ background: "#c91f27" }}
          disabled={disabled}
        >{tr("public:sendUsAMessageToRequestEnrolment_154")}</button>
      </form>
    </div>
  );
};

SignupForm.propTypes = {
  formData: PropTypes.shape({
    email: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    surname: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    childname: PropTypes.string.isRequired,
    age: PropTypes.string.isRequired,
    leveldesc: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired,
    typei: PropTypes.bool.isRequired,
    type2: PropTypes.bool.isRequired,
    typeg: PropTypes.bool.isRequired,
    desc: PropTypes.string.isRequired,
    permission: PropTypes.bool.isRequired,
    termsAccepted: PropTypes.bool.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default SignupForm;
